import React, { ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Tabs.scss";

interface Tab {
  label: ReactNode;
  content: ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  headerProps?: any;
  activeTab: number;
  onTabChange: (index: number) => void;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  headerProps,
}) => {
  return (
    <div className="tabs">
      <div className="tab-headers">
        {tabs.map((tab, index) => (
          <motion.button
            key={index}
            {...headerProps}
            className={`tab ${activeTab === index ? "active" : ""} `}
            onClick={() => onTabChange(index)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            {tab.label}
          </motion.button>
        ))}
      </div>
      <div className="tab-content overflow-x-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
          >
            {tabs[activeTab].content}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Tabs;
